import { useFeatures } from '@cdab/scania/qpr/feature-flags'
import { AuditDeviationPageNew } from './new-deviation'
import { AuditDraftDeviationPageNew } from './new-deviation-draft'

export const Page = (): JSX.Element => {
  const { draft_deviations } = useFeatures(['draft_deviations'])

  if (draft_deviations.enabled) {
    return <AuditDraftDeviationPageNew />
  }

  return <AuditDeviationPageNew />
}
